export function clamp(value: number, min: number, max: number) {
	return Math.min(Math.max(value, min), max);
}

export function lerp(min: number, max: number, t: number) {
	return min + (max - min) * t;
}

export function randomInRange(min: number, max: number) {
	return Math.random() * (max - min) + min;
}


